import withPageContext from './withPageContext';
import PageContext from './PageContext';

export { withPageContext as default, PageContext };
